import { VscDiffAdded } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import { addbusinesss } from "../../constant/import";
import { OrgItem } from "../../components/home/OrgItem";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { TasksIndicator } from "../../components/home/TasksIndicator";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { TasksItems } from "../../constant/data";
import useDepartmentHook from "../../hooks/useDepartmentHook";
import { useDeptHook } from "../../hooks/useDeptHook";

const OrganizationListing = () => {
  const { UserOrgs } = useOrganizationHook();
  const navigate = useNavigate();
  const { SelectedOrg, authuser } = useStateGetter();
   const { setSelectedorg } = useStateSetter();

  const TasksItems = [
    { name: "Create Account", checked: true },
    { name: "Verify Email", checked: true },
    { name: "Add Company", checked: UserOrgs.length > 0 },
    { name: "Add User", checked: false },
    { name: "Install Module", checked: false },
    { name: "Activate 2FA/MFA", checked: false },
  ];
  return (
    <div className="h-screen w-screen  flex justify-center  relative top-5  items-center ">
      <div className=" relative flex flex-row-reverse ">
        {!authuser.isEmployee && <TasksIndicator TasksItems={TasksItems} />}
        <div
          className={`grid ${
            UserOrgs.length > 0 ? "grid-cols-2" : "grid-cols-1"
          }   gap-4 `}
        >
          {UserOrgs.map((i) => (
            <OrgItem item={i} />
          ))}

          {!authuser.isEmployee && (
            <img
              onClick={() => {
                setSelectedorg({});
                navigate("/home/addorg");
              }}
              className="w-[160px] h-[150px] shadow-md rounded-[10px] p-1 "
              src={addbusinesss}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export { OrganizationListing };
